import { useEffect, useState } from 'react';
import useFetch from 'use-http';
import _ from 'lodash';
import { API } from 'common/constants/api-urls';
import moment from 'moment';
import { SEARCH_DATE_FORMAT, DAYS_PARAM } from 'common/constants/constants';
import { metricNames } from '@linearb/linjs-common';

const RELEASES_COUNT_LAST_X_DAYS = 14;
const FAILED_RELEASES_COUNT_VALUE = -1;

const useReleasesCount = ({
  sinceDaysCounter = RELEASES_COUNT_LAST_X_DAYS
} = {}) => {
  const [releasesCount, setReleasesCount] = useState(NaN);
  const { post, loading, error } = useFetch(API.METRICS_SEARCH_PATH);

  useEffect(() => {
    loadReleasesCount();
  }, []);

  const loadReleasesCount = async () => {
    try {
      setReleasesCount(NaN);
      const releases = await post('', {
        after: moment()
          .subtract(sinceDaysCounter, DAYS_PARAM)
          .format(SEARCH_DATE_FORMAT),
        before: moment().format(SEARCH_DATE_FORMAT),
        requested_metrics: [metricNames.RELEASES_COUNT],
        roll_up: 'custom',
        group_by: 'organization'
      });
      const count = _.get(
        releases,
        `[0]["items"][0]["${metricNames.RELEASES_COUNT}"]`,
        0
      );
      setReleasesCount(count);
    } catch (e) {
      setReleasesCount(FAILED_RELEASES_COUNT_VALUE);
    }
  };

  const isLoading = loading || isNaN(releasesCount);
  return {
    total: releasesCount,
    loading: isLoading,
    error: error || releasesCount === FAILED_RELEASES_COUNT_VALUE,
    sinceDaysCounter
  };
};

export default useReleasesCount;
